import { useRef, useEffect } from 'react';
import { Metrics } from '../../../metrics/protected/Metrics';
import { RICH_TEXT_EDITOR_TOTAL_RENDERS } from '../../../metrics/protected/constants';
import { localStorage } from 'conversations-platform/localStorage';
const DEBUG_MODE = !!localStorage.getItem('EDITOR_SHIELD_DEBUG');

/**
 * Hook to track re-renders for RichTextEditorProvider performance monitoring
 *
 * @param minRenderCount - The minimum number of renders to track.
 * Defaults to 10 to filter out the stats to actual threads that are being interacted with.
 */
export const useRenderCounter = (minRenderCount = 10) => {
  const renderCountRef = useRef(0);
  renderCountRef.current += 1;
  if (DEBUG_MODE) {
    // eslint-disable-next-line no-console
    console.debug('Tracking renders for this thread session', renderCountRef.current);
  }

  // Track final render count when component unmounts
  useEffect(() => {
    return () => {
      if (renderCountRef.current > minRenderCount) {
        // Track total renders for this thread session
        Metrics.histogram(RICH_TEXT_EDITOR_TOTAL_RENDERS).update(renderCountRef.current);
      }
    };
  }, [minRenderCount]);
};